import { createTheme } from '@mui/material';
import { csCZ } from '@mui/x-date-pickers/locales';
export const theme = createTheme(
  {
    palette: {
      mode: 'light',
      primary: {
        main: '#7B61FF',
        light: '#937EFF',
        dark: '#5237DD',
      },
      secondary: {
        main: '#1B2034',
        dark: '#0D1124',
        light: '#282E44',
        '300': '#5E6273',
        '200': '#9396A1',
        '100': '#C9CBD0',
      },
      background: {
        paper: '#FFFFFF',
        default: '#F3F3F3',
      },
      surface: {
        light: '#FAFAFA',
      },
      error: {
        main: '#EA173D',
      },
    },
    shadows: [
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
      'none',
    ],
    typography: {
      fontFamily: "'Plus Jakarta Sans', 'Helvetica', 'Arial', sans-serif",
      h1: { fontSize: '32px', lineHeight: '48px' },
      h2: { fontSize: '28px' },
      h3: { fontSize: '24px', lineHeight: '36px' },
      h4: { fontSize: '22px', fontWeight: 500, lineHeight: '32px' },
      h5: { fontSize: '20px', fontWeight: 500, lineHeight: '32px' },
      h6: { fontSize: '18px', fontWeight: 500 },
    },
    shape: {
      borderRadius: 16,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'inherit',
            paddingRight: '2rem',
            paddingLeft: '2rem',
          },
        },
      },
      MuiFilledInput: {
        styleOverrides: {
          root: {
            background: 'rgba(123, 97, 255, 0.1)',
          },
        },
      },
      MuiPaper: {
        defaultProps: {
          variant: 'outlined',
          elevation: 0,
        },
      },
    },
  },
  csCZ,
);
